import { render, staticRenderFns } from "./DetailUser.vue?vue&type=template&id=4991e053"
import script from "./DetailUser.vue?vue&type=script&lang=js"
export * from "./DetailUser.vue?vue&type=script&lang=js"
import style0 from "./DetailUser.vue?vue&type=style&index=0&id=4991e053&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports